/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

const EXPAND_ICON_STYLE = css`
  label: EXPAND_ICON_STYLE;
  width: 12px;
  height: 12px;
  transition: transform 0.2s ease;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EXPAND_ICON_LARGE_STYLE = css`
  label: EXPAND_ICON_LARGE_STYLE;
  width: 18px;
  height: 18px;
`;

const EXPAND_ICON_DOWN_STYLE = css`
  label: EXPAND_ICON_EXPANDED_STYLE;
  transform: rotate(0deg);
`;

const EXPAND_ICON_UP_STYLE = css`
  label: EXPAND_ICON_UP_STYLE;
  transform: rotate(-180deg);
`;

const EXPAND_ICON_RIGHT_STYLE = css`
  label: EXPAND_ICON_RIGHT_STYLE;
  transform: rotate(-90deg);
`;

const EXPAND_ICON_LEFT_STYLE = css`
  label: EXPAND_ICON_LEFT_STYLE;
  transform: rotate(90deg);
`;

const EXPAND_ICON_DIRECTION_STYLE = {
  up: EXPAND_ICON_UP_STYLE,
  down: EXPAND_ICON_DOWN_STYLE,
  left: EXPAND_ICON_LEFT_STYLE,
  right: EXPAND_ICON_RIGHT_STYLE,
};

export const ExpandIcon = ({ direction, expanded = false, upDownStyle = false, large = false, hidden = false, color = 'var(--text3)' }: {
  direction?: 'up' | 'down' | 'left' | 'right';
  expanded?: boolean;
  upDownStyle?: boolean;
  large?: boolean;
  hidden?: boolean;
  color?: string;
  rotate?: number;
}) => (
  <div
    css={[
      EXPAND_ICON_STYLE,
      large && EXPAND_ICON_LARGE_STYLE,
      direction
        ? EXPAND_ICON_DIRECTION_STYLE[direction]
        : upDownStyle
        ? expanded ? EXPAND_ICON_UP_STYLE : EXPAND_ICON_DOWN_STYLE
        : expanded
        ? EXPAND_ICON_DOWN_STYLE
        : EXPAND_ICON_RIGHT_STYLE,
    ]}
    style={{ opacity: hidden ? 0 : 1 }}
  >
    <svg width={large ? '17' : '12'} height={large ? '11' : '8'} viewBox='0 0 17 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.23808 9.92943C8.8416 10.3631 8.1584 10.3632 7.76192 9.92943L2.6697 4.35892C2.08308 3.71719 2.53833 2.68421 3.40779 2.68421L13.5922 2.68421C14.4617 2.68421 14.9169 3.71719 14.3303 4.35892L9.23808 9.92943Z'
        fill={color}
      />
    </svg>
  </div>
);
